export class Partner {
    id: string;
    idBusinessPartner: string;
    nomeBusinessPartner: string;
}